import React from "react";
 
const PlusIconRed = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.3333 16.9997H11.6666V11.6663H16.9999V10.333H11.6666V4.99967H10.3333V10.333H4.99992V11.6663H10.3333V16.9997ZM0.333252 21.6663V0.333008H21.6666V21.6663H0.333252ZM1.66659 20.333H20.3333V1.66634H1.66659V20.333Z" fill="#C80000" />
        </svg>
    );
};
 
export default PlusIconRed;